import { Component, inject, OnInit, signal } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { AuxiliaresModule } from '../../../../../auxiliares/auxiliares.module';
import { DialogService } from '../../../../../auxiliares/dialog/dialog.service';
import { HelperService } from '../../../../../auxiliares/servicios/helper.service';
import {
  ReportesTruchosService,
  QuerySimuladorTracker,
} from '../../../../../auxiliares/servicios/http/reportes-truchos.service';
import { ParamsService } from '../../../../../auxiliares/servicios/params.service';
import { IQueryParam, IRecorrido } from 'modelos/src';
import { firstValueFrom, Subscription } from 'rxjs';
import { Lista2Service } from '../../../../../auxiliares/servicios/lista2.service';

@Component({
  imports: [AuxiliaresModule],
  selector: 'app-simulador-tracker',
  templateUrl: './simulador-tracker.component.html',
  styleUrl: './simulador-tracker.component.scss',
})
export class SimuladorTrackerComponent implements OnInit {
  // Props
  public title = signal('Simular Tracker');
  public trackerId = signal<string | undefined>(undefined);
  public loading = signal(false);
  public form = signal<FormGroup | null>(null);
  public recorridos = signal<IRecorrido[]>([]);
  public recorridos$?: Subscription;
  // Inyectables
  private readonly service = inject(ReportesTruchosService);
  public readonly helper = inject(HelperService);
  private readonly dialogService = inject(DialogService);
  private readonly paramsService = inject(ParamsService);
  public readonly dialog = inject(MatDialog);
  public readonly lista2 = inject(Lista2Service);

  private createForm() {
    this.form.set(
      new FormGroup({
        trackerId: new FormControl(
          { value: this.trackerId(), disabled: true },
          Validators.required,
        ),
        durationHours: new FormControl(1, [
          Validators.required,
          Validators.min(0.1),
        ]),
        speedKmh: new FormControl(60, [
          Validators.required,
          Validators.min(1),
          Validators.max(200),
        ]),
        recorrido: new FormControl(null, Validators.required),
      }),
    );
  }

  private async listarRecorridos(): Promise<void> {
    const query: IQueryParam = {
      select: 'nombre geojson',
    };
    this.recorridos.set(
      (await firstValueFrom(this.lista2.recorridos(query))).datos,
    );
  }

  private getData(): QuerySimuladorTracker {
    const formValue = this.form()?.getRawValue();
    const recorrido: IRecorrido = formValue.recorrido;
    return {
      trackerId: formValue.trackerId,
      durationHours: formValue.durationHours,
      speedKmh: formValue.speedKmh,
      route: recorrido.geojson,
    };
  }

  public async onSubmit() {
    if (!this.form()?.valid) {
      this.helper.notifError('Completá todos los campos requeridos');
      return;
    }

    const res = await this.dialogService.confirm(
      'Confirmá la acción',
      '¿Querés iniciar la simulación del tracker?',
    );
    if (!res) return;

    this.loading.set(true);
    try {
      const data = this.getData();
      await this.service.simularTracker(data);
      this.helper.notifSuccess('Simulación iniciada correctamente');
      this.dialog.closeAll();
    } catch (error) {
      console.error(error);
      this.helper.notifError('Error al iniciar la simulación');
    } finally {
      this.loading.set(false);
    }
  }

  public cerrar() {
    this.dialog.closeAll();
  }

  async ngOnInit() {
    const params = this.paramsService.getParams();
    this.trackerId.set(params['trackerId']);
    this.createForm();
    await this.listarRecorridos();
  }
}
